import { action } from 'satcheljs';

import type { OwaNovaActionUnion } from '../types';

export const onStartChatViaSipProtocol = action('onStartChatViaSipProtocol', event => ({
    event,
    owaType: 'startChatViaSipProtocol',
})) as OwaNovaActionUnion<'startChatViaSipProtocol'>;
